const INITIAL_DRAFT_ORIGINS = new Set([
  'superadmin-initial-draft',
  // Tasks created before the explicit superadmin button was introduced.
  'superadmin-invite',
]);

export function isSuperadminInitialDraft(createdBy?: string | null): boolean {
  return INITIAL_DRAFT_ORIGINS.has(createdBy || '');
}
